// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

import {
    ITextFieldStyles,
    TextField,
} from 'office-ui-fabric-react';

import RepairItemDetail from './../../../components/RepairItemDetail/RepairItemDetail';

import Styles from './styles.module.scss';

const TextFieldStyle: Partial<ITextFieldStyles> = {
    root: {
        width: 520,
        marginTop: 20,
    },
};

export default function AccessorySection(props: any) {
    const {accessories} = props;

    if (!accessories || !accessories.length) {
        return null;
    }

    const {t} = useTranslation();

    function onDescriptionChange(
        event: any,
        value: string | undefined) {
        const accessory = accessories.find((accessory: any)=> accessory.sku === event.target.name);

        props.onAccessoryProblemDescriptionChange(accessory, value);
    }
    return (
        <section className={Styles.accessoryContainer}>
            <h3 className={Styles.h3Heading}>{t('accessory')}</h3>
            {accessories.map((accessory: any, key: number) => {
                const className= clsx(
                    Styles.accessorySection,
                    {
                        [Styles.withBorder]: key < accessories.length - 1,
                    }
                );

                return (
                    <div className={className} key={key}>
                        <RepairItemDetail
                            data={[
                                {
                                    name: accessory.name,
                                },
                            ]}
                            title={t('accessory')}
                        />
                        <TextField
                            ariaLabel={t('problem_description_for', { itemName: accessory.name })}
                            onRenderLabel={onLabelRender}
                            styles={TextFieldStyle}
                            name={accessory.sku}
                            label={t('problem_description')}
                            multiline={true}
                            rows={5}
                            onChange={onDescriptionChange}
                        />
                    </div>
                );
            })}
        </section>
    );
}

function onLabelRender(props: any): JSX.Element {
    return <label className={Styles.textAreaLabel}>{props.label}</label>;
}